import { Theme, makeStyles } from '@material-ui/core/styles';

import Header from 'components/Header';
// eslint-disable-next-line
import React from 'react';
import cx from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    position: 'relative',
  },
  rootWithBackground: { backgroundColor: theme.palette.grey[200] },
  mainContainer: {
    padding: theme.spacing(3),
    flex: '1',
  },
}));

const Layout = ({ children, background = true }) => {
  const classes = useStyles();

  return (
    <div
      className={cx(classes.root, {
        [classes.rootWithBackground]: background,
      })}
    >
      <Header />
      <main className={classes.mainContainer}>{children}</main>
    </div>
  );
};

export default Layout;
